function handleResize() {
  document.documentElement.style.setProperty('--client-height', `${window.innerHeight}px`);
}

window.addEventListener('resize', handleResize);
window.addEventListener('orientationchange', handleResize);
handleResize();
